const bodyStyle = { fontSize: "16px", lineHeight: 1.7, color: "rgba(10,9,7,0.85)", margin: 0 };

/**
 * "Ehrenamt" copy, as provided directly by the association (replaces the
 * earlier generic placeholder wording). German is the primary/authoritative
 * wording; English is a courtesy translation.
 */
export function VolunteerDe() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <p style={bodyStyle}>
        Hinter jedem gelungenen Event steckt weit mehr als Magie – es steckt ein Team aus Menschen, die anpacken,
        mitdenken und mitgestalten. Als gemeinnützige Organisation lebt Tales&amp;Legends vom Engagement derer, die
        unsere Leidenschaft teilen und bereit sind, einen Teil ihrer Zeit einzubringen.
      </p>
      <p style={bodyStyle}>
        Du musst kein LARP-Profi sein, um mitzumachen. Was du mitbringen solltest: Begeisterung, Zuverlässigkeit und
        Lust, etwas gemeinsam aufzubauen.
      </p>
      <p style={bodyStyle}>
        Ob hinter den Kulissen in der Orga, in der direkten Betreuung bei unseren Jugend-Events oder mit
        handwerklichem Geschick beim Aufbau von Kulissen und Requisiten – es gibt viele Wege, Teil des Teams zu
        werden. Als kleines Dankeschön ermöglichen wir engagierten Ehrenamtlichen je nach Umfang des Einsatzes
        vergünstigte oder kostenfreie Tickets für unsere Events.
      </p>
      <p style={bodyStyle}>
        Du hast Interesse oder möchtest einfach mal unverbindlich reinschnuppern? Schreib uns – wir freuen uns über
        jede:n, der die Welt von Tales&amp;Legends ein Stück größer macht.
      </p>
    </div>
  );
}

/** Courtesy translation — German is the primary wording (see VolunteerDe). */
export function VolunteerEn() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <p style={bodyStyle}>
        Behind every successful event is far more than magic – there's a team of people who pitch in, think ahead,
        and help shape things. As a non-profit organization, Tales&amp;Legends lives on the commitment of those who
        share our passion and are willing to give some of their time.
      </p>
      <p style={bodyStyle}>
        You don't need to be a LARP pro to get involved. What you should bring: enthusiasm, reliability, and a
        desire to build something together.
      </p>
      <p style={bodyStyle}>
        Whether behind the scenes in organizing, in direct supervision at our youth events, or with hands-on skill
        building sets and props – there are many ways to become part of the team. As a small thank-you, depending
        on the scope of your involvement, we offer engaged volunteers discounted or free tickets to our events.
      </p>
      <p style={bodyStyle}>
        Interested, or would you just like to take a no-strings-attached look? Write to us – we're happy about
        everyone who helps make the world of Tales&amp;Legends a little bigger.
      </p>
    </div>
  );
}
